import { IEntity, ObjectState } from '../interfaces/entity';
import { DataField } from './data-field';
import {Template, TEMPLATE_TYPE} from './template';

export interface IProcessTypeList{
  items: ProcessType[];
  totalCount: number;
}

export class ProcessType implements IEntity {
  id: number;
  uid: string;
  name: string;
  description: string;
  summary: string;
  hideRecord: boolean;
  dataFields: DataField[];
  processTypeTemplates: ProcessTypeTemplate[];
  color: string;
  locked: boolean;
  canDelete: boolean;
  isFTSUDemographics: boolean = false;
  isCheckList:boolean=false;
  caseCategoryId:number=-1;
  caseTypeId:number=-1;
  caseStatusId: number=-1;
  isCaseReopenedChecklist: boolean=false;

  constructor(processType?)
    {
        processType = processType || {};
        this.id = processType.id;
        this.uid = processType.uid;
        this.name = processType.name || '';
        this.hideRecord = processType.hideRecord || '';
        this.description = processType.description || '';
        this.summary = processType.summary || '';
        this.canDelete = processType.canDelete;
        this.locked = processType.locked;
        this.isCheckList = processType.isCheckList || false;
        this.caseCategoryId = processType.caseCategoryId;
        this.caseTypeId = processType.caseTypeId;
        this.caseStatusId = processType.caseStatusId;
        this.isCaseReopenedChecklist = processType.isCaseReopenedChecklist || false;
        this.isFTSUDemographics = processType.isFTSUDemographics || false;
        this.dataFields = processType.dataFields || [
          {
            id: 1,
            name: 'Summary',
            dataType: 'Text',
            min: 1,
            max: 500,
            label: 'Summary',
            required: false,
            default: '',
           fixed: true,
           objectState: ObjectState.Added,
          },
          {
            id: 2,
            name: 'LinkedSubject',
            dataType: 'Text',
            min: 1,
            max: 500,
            label: 'Linked Subject',
            required: false,
            readOnly: true,
            fixed: true,
            objectState: ObjectState.Added,
          },
      ],
      this.processTypeTemplates = processType.processTypeTemplates || [];
        this.color = processType.color || '#0277bd';
    }

  getDataField(name: string): DataField {
    return this.dataFields.find((item) => item.name.toLowerCase() === name.toLowerCase());
  }

  getFieldId(name: string): number{
    const dataField = this.getDataField(name);
    return (dataField) ? dataField.id : -1;
  }
  
  private getTemplate(type: string): Template{
    let processTypeTemplate = this.processTypeTemplates.find((x) => x.template.type === type);
    if (!processTypeTemplate){
      processTypeTemplate = new ProcessTypeTemplate(this.id, type);
      this.processTypeTemplates.push(processTypeTemplate);
    }
    return processTypeTemplate.template;
  }

  private setTemplate(val: Template){
    const processTypeTemplate = this.processTypeTemplates.find((x) => x.template.type === val.type);
    if (processTypeTemplate){
      processTypeTemplate.templateId = val.id;
      processTypeTemplate.template = val;
    }
    else{
      this.processTypeTemplates.push(new ProcessTypeTemplate(this.id, val.type, val));
    }
  }

  get editTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.EDIT);
  }

  set editTemplate(val: Template){
    this.setTemplate(val);
  }

  get cardTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.CARD);
  }

  set cardTemplate(val: Template){
    this.setTemplate(val);
  }

  get listTemplate(): Template{
    return this.getTemplate(TEMPLATE_TYPE.LIST);
  }

  set listTemplate(val: Template){
    this.setTemplate(val);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class ProcessTypeTemplate implements IEntity{
  id: number;
  uid: string;
  processTypeId: number;
  templateId: number;
  template: Template;

  constructor(processTypeId: number, templateType: string, template?: Template){
    this.processTypeId = processTypeId;
    if (template){
      this.templateId = template.id;
      this.template = template;
    }
    else{
      this.template = new Template(templateType);
      this.template.objectState = ObjectState.Added;
    }
  }
}
